import { MezoModalProps } from "#/shared/types"

import { StepperModal } from "../StepperModal"

import AddFundsStep from "./AddFundsStep"
import BridgeReviewStep from "./BridgeReviewStep"

export default function BridgeAssetModal(props: MezoModalProps) {
  return (
    <StepperModal
      {...props}
      steps={[
        {
          title: "Add funds",
          withCloseButton: true,
          component: AddFundsStep,
        },
        {
          title: "Review",
          withCloseButton: true,
          component: BridgeReviewStep,
        },
      ]}
      // TODO: Temporary solution
      overrides={{
        Dialog: {
          style: () => ({
            width: "548px",
            height: "fit-content",
          }),
        },
      }}
    />
  )
}
